import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CircuitSample from 'assets/images/circuitSample.svg';
import colors from 'styles/colors';

const styles = {
  announcement: {
    maxWidth: '320px',
    zIndex: '1',
  },
  note: {
    zIndex: '1',
  },
  banner: {
    background: '#9C5BBF',
    height: '70px',
    overflow: 'hidden',
    // border: '1px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '10px',
    marginBottom: '24px',
    position: 'relative',
    width: '100%',
  },
  background: {
    // background: 'rgba(196,196,196, 085)',
    background: 'linear-gradient(90deg, rgba(6,6,31,0.5) 0%, rgba(6,6,31,1) 100%)',
  },
  border: {
    background: 'radial-gradient(100% 100% at 49.93% 0%, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.06) 100%), linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
    display: 'flex',
    padding: '10px 40px',
    height: '50px',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  circuitSample: {
    width: '506px',
    height: '248px',
    left: 'calc(50% - 477.25px/2 + 45.82px)',
    top: 'calc(50% - 248.28px/2 + 76.22px)',
    borderRadius: '8px',
    transform: 'rotate(-15deg)',
    opacity: '0.7',
    alignSelf: 'center',
  },
  closeIcon: {
    cursor: 'pointer',
    position: 'absolute',
    right: '15px',
    top: '15px',
  },
};

const Banner = ({
  announcement, note, callForAction, actionHandler,
}) => {
  const [isOpened, setIsOpened] = useState(true);

  const handleBannerToggle = () => {
    setIsOpened(!isOpened);
  };

  return isOpened ? (
    <Box sx={styles.banner} id="banner">
      <Box sx={styles.background}>
        <Box sx={styles.border}>
          <Box>
            <Typography variant="h6" sx={styles.announcement} color={colors.text.primary}>
              {announcement}
            </Typography>
            {note && (
              <Typography variant="helper" sx={styles.note} color={colors.text.secondary}>
                {note}
              </Typography>
            )}
          </Box>
          <CircuitSample style={styles.circuitSample} />
          <Button
            sx={{ minWidth: '200px', cursor: 'pointer' }}
            type="primary"
            variant="contained"
            onClick={actionHandler}
          >
            {callForAction}
          </Button>
        </Box>
      </Box>
      <CloseIcon
        fontSize="12px"
        htmlColor={colors.text.primary}
        sx={styles.closeIcon}
        onClick={handleBannerToggle}
      />
    </Box>
  ) : null;
};

export default Banner;
